import React from "react";
import ThreeScene from "./mv/ThreeScene";
function App() {
  return <ThreeScene />;
}
export default App;
